import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const PlatformLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
      const res = await axios.post(`${API_URL}/api/authorized-admin/login`, { email, password });
      localStorage.setItem('sys_token', res.data.sys_token);
      navigate('/add-workspaces/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Access denied. Authorized system admins only.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
            <div style={styles.logoPlaceholder}>🛡️</div>
            <h1 style={styles.title}>System Admin</h1>
            <p style={styles.subtitle}>Vetobase Management Console</p>
        </div>
        <form onSubmit={handleLogin}>
          <div style={styles.field}>
            <label style={styles.label}>Root Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="e.g. system@vetobase.com"
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Access Key</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="••••••••"
              required
            />
          </div>
          <button type="submit" disabled={loading} style={{...styles.button, background: '#111111'}}>
            {loading ? 'Initializing Console...' : 'Unlock Management Console'}
          </button>
          
          {error && <div style={styles.errorBox}>{error}</div>}
        </form>
      </div>
    </div>
  );
};

const styles = {
    page: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#F9F4EE',
      padding: 20,
      fontFamily: '"Outfit", sans-serif'
    },
    card: {
      width: '100%', 
      maxWidth: 400, 
      background: '#fff', 
      borderRadius: 12,
      padding: '40px 32px', 
      border: '1px solid #E7E1D6',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    },
    header: { textAlign: 'center', marginBottom: 32 },
    logoPlaceholder: { 
        width: 80, height: 80, background: '#111111', borderRadius: '50%', margin: '0 auto 16px', border: '2px solid #F9F4EE',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px'
    },
    title: { margin: 0, fontSize: 24, fontWeight: 700, color: '#111111' },
    subtitle: { margin: '8px 0 0', color: '#6B6862', fontSize: 14 },
    field: { marginBottom: 20, textAlign: 'left' },
    label: { display: 'block', fontSize: 13, fontWeight: 500, color: '#111111', marginBottom: 6 },
    input: { 
      width: '100%', 
      padding: '10px 12px', 
      borderRadius: 6, 
      border: '1px solid #ccc', 
      outline: 'none',
      boxSizing: 'border-box',
      fontSize: '14px',
      transition: 'border-color 0.2s'
    },
    button: { 
      width: '100%', 
      padding: '12px', 
      borderRadius: 6, 
      border: 'none', 
      background: '#111111', 
      color: '#fff', 
      fontWeight: 600, 
      cursor: 'pointer',
      fontSize: '14px',
      transition: 'background 0.2s'
    },
    errorBox: { 
      fontSize: 13, 
      color: '#B0361F', 
      textAlign: 'center', 
      marginTop: 12, 
      background: '#FBEDE9', 
      padding: '8px 12px', 
      borderRadius: 6, 
      border: '1px solid #F6E4E1' 
    }
  };

export default PlatformLogin;
